<template>
  <v-footer
    id="core-footer"
    absolute
    height="82" >
    <v-select
      v-model="currentLanguage"
      :items="languages"
      item-value="code"
      item-text="language"
      box
      label="Language"
      @change="onLanguageChange"/>
    <v-spacer/>
    <div class="footer-items">
      <span
        v-for="link in links"
        :key="link.name"
      >
        <a
          :href="link.Link"
          class="tertiary--text footer-links">{{ link.name }}</a>
      </span>
    </div>
    <span class="font-weight-light copyright">
      &copy;
      {{ (new Date()).getFullYear() }}
      <a
        href="https://www.startitaliana.com/"
        target="_blank">Start</a>
    </span>
  </v-footer>
</template>

<script>
import { loadLanguageAsync } from '@/i18n'

export default {
  data: () => ({
    links: [
      { name: 'Home', Link: '/dashboard' }
    ],
    languages: [],
    currentLanguage: ''
  }),
  mounted () {
    if (localStorage.currentLanguage) {
      this.currentLanguage = localStorage.currentLanguage
    } else {
      this.currentLanguage = this.$i18n.locale
    }

    this.Maglink.GetLanguages()
      .then((resp) => (this.languages = resp.data))
      .catch(error => (this.snack('error', error.message)))
  },
  methods: {
    onLanguageChange () {
      localStorage.currentLanguage = this.currentLanguage
      loadLanguageAsync(this.currentLanguage, this)
    },
    snack (color, message) {
      message = 'Footer: ' + message
      this.$store.dispatch('showSnackbar', { color, message, show: true })
    }
  }
}
</script>

<style>
#core-footer {
  z-index: 0;
}
</style>
